webpackJsonp([243066350126013],{

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(9);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(604);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // vendor
	
	
	// utils
	
	
	// styles
	
	
	var Element = function Element(_ref) {
	  var children = _ref.children,
	      elementClicked = _ref.elementClicked,
	      selected = _ref.selected;
	  return _react2.default.createElement(
	    'button',
	    {
	      onClick: function onClick(e) {
	        return elementClicked(e);
	      },
	      className: (0, _classnames2.default)('element-selector__button', { 'element-selector__button--is-selected': selected })
	    },
	    children
	  );
	};
	
	var ElementSelector = function (_Component) {
	  _inherits(ElementSelector, _Component);
	
	  function ElementSelector() {
	    _classCallCheck(this, ElementSelector);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ElementSelector.prototype.handleClick = function handleClick(e) {
	    this.props.elementClicked(e);
	  };
	
	  ElementSelector.prototype.isSelectedElement = function isSelectedElement(el) {
	    var elementSelected = this.props.elementSelected;
	
	    return el === elementSelected;
	  };
	
	  ElementSelector.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        elements = _props.elements,
	        title = _props.title;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'element-selector' },
	      _react2.default.createElement(
	        'p',
	        { className: 'element-selector__title' },
	        title
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: 'element-selector__list' },
	        elements.map(function (element) {
	          return _react2.default.createElement(
	            'li',
	            { className: 'element-selector__list-item', key: element.key },
	            _react2.default.createElement(
	              Element,
	              {
	                elementClicked: function elementClicked() {
	                  return _this2.handleClick(element.key);
	                },
	                selected: _this2.isSelectedElement(element.key)
	              },
	              element.value
	            )
	          );
	        })
	      )
	    );
	  };
	
	  return ElementSelector;
	}(_react.Component);
	
	Element.propTypes = {
	  children: _propTypes2.default.string.isRequired,
	  elementClicked: _propTypes2.default.func.isRequired,
	  selected: _propTypes2.default.bool
	};
	
	Element.defaultProps = {
	  selected: false
	};
	
	ElementSelector.propTypes = {
	  elements: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    key: _propTypes2.default.string.isRequired,
	    value: _propTypes2.default.string.isRequired
	  })).isRequired,
	  elementClicked: _propTypes2.default.func.isRequired,
	  elementSelected: _propTypes2.default.string,
	  title: _propTypes2.default.string
	};
	
	ElementSelector.defaultProps = {
	  title: null,
	  elementSelected: null
	};
	
	exports.default = ElementSelector;
	module.exports = exports['default'];

/***/ }),

/***/ 604:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(37);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// utils
	var PageIntro = function PageIntro(_ref) {
	  var children = _ref.children,
	      title = _ref.title;
	  return _react2.default.createElement(
	    'div',
	    { className: 'page-intro' },
	    _react2.default.createElement(
	      'h1',
	      { className: 'page-intro__title' },
	      title
	    ),
	    _react2.default.createElement(
	      'p',
	      { className: 'page-intro__text' },
	      children
	    )
	  );
	};
	
	// style
	// vendor
	
	
	PageIntro.propTypes = {
	  title: _propTypes2.default.string.isRequired,
	  children: _propTypes2.default.string.isRequired
	};
	
	exports.default = PageIntro;
	module.exports = exports['default'];

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ArticleList = __webpack_require__(28);
	
	var _ArticleList2 = _interopRequireDefault(_ArticleList);
	
	var _ElementSelector = __webpack_require__(137);
	
	var _ElementSelector2 = _interopRequireDefault(_ElementSelector);
	
	var _PageTitle = __webpack_require__(16);
	
	var _PageTitle2 = _interopRequireDefault(_PageTitle);
	
	var _PageIntro = __webpack_require__(29);
	
	var _PageIntro2 = _interopRequireDefault(_PageIntro);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // vendor
	
	
	// vendor components
	
	
	// utils
	
	
	// components
	
	
	var formatElementSelectorList = function formatElementSelectorList(list) {
	  return list.map(function (_ref) {
	    var slug = _ref.slug,
	        name = _ref.name;
	    return { key: slug, value: name };
	  });
	};
	
	var VoyagesPage = function (_Component) {
	  _inherits(VoyagesPage, _Component);
	
	  function VoyagesPage(props) {
	    _classCallCheck(this, VoyagesPage);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      countrySelected: _this.getSlugFromLocation() || _this.getCountries()[0].slug || null
	    };
	    return _this;
	  }
	
	  VoyagesPage.prototype.getArticlesFormated = function getArticlesFormated(slug) {
	    return this.getArticleswhitCountrySlug(slug).map(function (node) {
	      return {
	        thumbnail: {
	          sizes: node.hero.sizes,
	          alt: node.hero.title
	        },
	        date: node.publicationDate,
	        title: node.title,
	        excerpt: node.description.description,
	        id: node.id,
	        path: node.fields.path
	      };
	    });
	  };
	
	  VoyagesPage.prototype.getArticleswhitCountrySlug = function getArticleswhitCountrySlug(countrySlug) {
	    var articles = this.props.data.articles.edges;
	
	
	    return articles.map(function (_ref2) {
	      var article = _ref2.node;
	      return article;
	    }).filter(function (_ref3) {
	      var slug = _ref3.country.slug;
	      return slug === countrySlug;
	    });
	  };
	
	  VoyagesPage.prototype.getCountries = function getCountries() {
	    var articles = this.props.data.articles.edges;
	
	
	    return articles.reduce(function (acc, _ref4) {
	      var country = _ref4.node.country;
	
	      if (acc.find(function (_ref5) {
	        var slug = _ref5.slug;
	        return slug === country.slug;
	      })) {
	        return acc;
	      }
	
	      return [].concat(acc, [country]);
	    }, []);
	  };
	
	  VoyagesPage.prototype.getSlugFromLocation = function getSlugFromLocation() {
	    var pathname = this.props.location.pathname;
	
	    var path = pathname.split('/').filter(function (e) {
	      return e.length;
	    });
	
	    return path[1] ? path[1] : null;
	  };
	
	  VoyagesPage.prototype.handleClick = function handleClick(slug) {
	    window.history.pushState({}, '', '/voyages/' + slug + '/');
	
	    this.setState({ countrySelected: slug });
	  };
	
	  VoyagesPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var countrySelected = this.state.countrySelected;
	
	    var coutriesList = this.getCountries();
	    var articles = this.getArticlesFormated(countrySelected);
	    var _props$data$site$site = this.props.data.site.siteMetadata,
	        siteUrl = _props$data$site$site.siteUrl,
	        siteTitle = _props$data$site$site.title;
	    var pathname = this.props.location.pathname;
	
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          'Voyages | ' + siteTitle
	        ),
	        _react2.default.createElement('meta', {
	          name: 'description',
	          content: 'Guides de voyages brassicoles dans des cultures traditionnelles de l\'Allemagne au Bhoutan, de la Bolivie \xE0 la Norv\xE8ge'
	        }),
	        _react2.default.createElement('meta', { name: 'twitter:card', value: 'summary' }),
	        _react2.default.createElement('meta', {
	          property: 'og:title',
	          content: 'Voyages | Les coureurs des boires'
	        }),
	        _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	        _react2.default.createElement('meta', { property: 'og:url', content: '' + siteUrl + pathname }),
	        _react2.default.createElement('meta', {
	          property: 'og:description',
	          content: 'Guides de voyages brassicoles dans des cultures traditionnelles de l\'Allemagne au Bhoutan, de la Bolivie \xE0 la Norv\xE8ge'
	        }),
	        _react2.default.createElement('meta', { property: 'og:site_name', content: 'Les coureurs des boires' }),
	        _react2.default.createElement('link', { rel: 'canonical', href: '' + siteUrl + pathname })
	      ),
	      _react2.default.createElement(_PageTitle2.default, { title: 'Voyages' }),
	      _react2.default.createElement(
	        _PageIntro2.default,
	        { title: 'Voyages d\'exploration brassicole' },
	        'L\'univers de la bi\xE8re est bien plus vaste que ce que nous croyons. Voici quelques-uns de nos voyages de recherche qui nous ouvert l\'esprit... et l\'app\xE9tit!'
	      ),
	      _react2.default.createElement(_ElementSelector2.default, {
	        title: 'Liste de pays',
	        elements: formatElementSelectorList(coutriesList),
	        elementClicked: function elementClicked(e) {
	          return _this2.handleClick(e);
	        },
	        elementSelected: countrySelected
	      }),
	      _react2.default.createElement(_ArticleList2.default, { articles: articles, title: 'Articles li\xE9s' })
	    );
	  };
	
	  return VoyagesPage;
	}(_react.Component);
	
	var query = exports.query = '** extracted graphql fragment **';
	
	VoyagesPage.propTypes = {
	  data: _propTypes2.default.shape({
	    articles: _propTypes2.default.shape({
	      edges: _propTypes2.default.array
	    }),
	    site: _propTypes2.default.shape({
	      siteMetadata: _propTypes2.default.shape({
	        title: _propTypes2.default.string,
	        siteUrl: _propTypes2.default.string
	      })
	    })
	  }).isRequired,
	  location: _propTypes2.default.shape({
	    pathname: _propTypes2.default.string.isRequired
	  }).isRequired
	};
	
	exports.default = VoyagesPage;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-voyages-index-jsx-e7fd1af64ba0804b8560.js